export default {
  errorsContainer: {
    color: 'red',
    paddingTop: '10px',
    display: 'grid',
  }
};



// WEBPACK FOOTER //
// ./src/common/UiComponent/style.js